// @flow
import type { SrcSetType } from 'app/common/react/components/growth/unauth/lib/PropTypes';

export const createImageCSS = (url: string, width: string, height: string) =>
  `background-image:
      url: "${url}";
      background-size: ${width} ${height};
      background-repeat: no-repeat;`;

const getFirstValidImageSize = (pin: Object, sizes: ?Array<string>): ?string => {
  if (sizes) {
    for (const size of sizes) {
      if (size in pin.images) {
        return pin.images[size].url;
      }
    }
  }
  return null;
};

export const getSrcSet = (pin: Object, srcSet: SrcSetType): string => {
  const { oneXSizes, twoXSizes, threeXSizes } = srcSet;
  const results = [];
  const oneXImageUrl = getFirstValidImageSize(pin, oneXSizes);
  if (oneXImageUrl) {
    results.push(`${oneXImageUrl} 1x`);
  }
  const twoXImageUrl = getFirstValidImageSize(pin, twoXSizes);
  if (twoXImageUrl) {
    results.push(`${twoXImageUrl} 2x`);
  }
  const threeXImageUrl = getFirstValidImageSize(pin, threeXSizes);
  if (threeXImageUrl) {
    results.push(`${threeXImageUrl} 3x`);
  }
  return results.join(', ');
};
